export const formattedValue = (value: number) => {
  const formattedValue = value.toFixed(1)

  return String(formattedValue).replace('.', ',')
}
